'use client'

import { useEffect, useState } from 'react'
import { attributionFromParams, buildStoreLinks, type StoreLinks } from './storeLinks'

/**
 * Store links attributed from the current page's UTMs. Renders with the
 * default attribution first (SSR/hydration-safe), then reads
 * window.location.search once on mount.
 */
export function useStoreLinks(): StoreLinks {
  const [links, setLinks] = useState<StoreLinks>(() => buildStoreLinks(attributionFromParams(undefined)))

  useEffect(() => {
    // eslint-disable-next-line react-hooks/set-state-in-effect -- one-time read of the URL after hydration
    setLinks(buildStoreLinks(attributionFromParams(new URLSearchParams(window.location.search))))
  }, [])

  return links
}
